export class Donvi {
  id: number;
  ma: string;
  tendonvi: string;
  diaban: number;
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;  
  email: string;
  duocnhanmail: number;
  donvixuly: number;
  madinhdanh: string;
 }